module.exports = __webpack_public_path__ + "static/media/meter-normal.112d2362.png";